import { ourprocess } from "../../utilities/process"
import Booking from "../Illustrations/Booking"
import PaymentIllus from "../Illustrations/PaymentIllus"
import RegisterIllus from "../Illustrations/RegisterIllus"
import Verified from "../Illustrations/Verified"

const Process = () => {
	return (
		<div id='process' className='app-x py-14 bg-gradient-to-b from-slate-50 via-white to-slate-50'>
			<h3 className="text-primary uppercase font-serif text-center font-black text-2xl">Our Process</h3>
			<hr className="w-1/3 mx-auto mt-5 mb-10 " />
			<div>
				{ourprocess.map(({ title, text, id }, i) => (
					<div key={i} className=" flex flex-col md:flex-row md:even:flex-row-reverse group">
						<div className="md:w-1/2 w-full pb-10 lg:pb-20 group-last:pb-0 rounded-lg group-even:pl-8 group-odd:pr-8 flex md:group-odd:justify-end">
							{id === 1 && <Booking />}
							{id === 2 && <RegisterIllus />}
							{id === 3 && <PaymentIllus />}
							{id === 4 && <Verified />}
						</div>
						<div className="md:w-1/2 w-full group-odd:pl-10 group-even:pr-10 relative group-odd:border-l group-even:border-r md:border-none">
							<h3 className="mb-2 font-serif text-base font-bold">{title}</h3>
							<p className="text-slate-500 text-sm">{text}</p>
							<div className="absolute hidden md:block border-l-2 -top-[.3rem] border-dashed h-full group-odd:-left-[.17rem] group-even:-right-[2rem]">
								<div className="border-2 border-dashed border-tan -left-[17px] bg-slate-50 relative h-8 w-8 rounded-full after:bg-primary after:inset-2 after:absolute after:rounded-full"></div>
							</div>
						</div>
					</div>
				))}
			</div>
		</div>
	)
}

export default Process